import React, { useContext } from "react";
import { FindifyNavigation } from "../components/FindifyNavigation";
import { Text, View } from "react-native";
import { PlaceColors } from "./PlaceColors";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { useSeoTitle } from "./SeoTitle";
import { useStatisticsPageView } from "./StatisticsHelper";
import { getWorkspaceTitle } from "./WorkspaceText";

const routeSeoTitles: Record<string, string> = {
    Place: 'Início',
    PlantsPage: 'Mapa Interativo',
    PlaceMap: 'Mapa',
    PlaceInfo: 'O Museu',
    PlaceContentList: 'Conteúdos',
    PlaceContentDetails: 'Conteúdo',
    ScanQR: 'Ler QR Code',
    Scan: 'Scanner',
    Profile: 'Perfil',
    SchedulePage: 'Agenda',
};

const normalizeViewChildren = (children: React.ReactNode) => {
    return React.Children.map(children, (child) => {
        if (typeof child === 'string') {
            if (child.trim().length === 0) return null;
            return <Text>{child}</Text>;
        }

        if (typeof child === 'number') {
            return <Text>{child}</Text>;
        }

        return child;
    });
}

export const BasePage = ({ ...props }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const currentRoute = props.navigation?.getState?.()?.routes?.[props.navigation?.getState?.()?.index ?? 0];
    useSeoTitle(
        props.seoTitle ?? routeSeoTitles[currentRoute?.name] ?? currentRoute?.name,
        getWorkspaceTitle(findifyDataContext)
    );
    useStatisticsPageView({
        findifyDataContext,
        routeName: currentRoute?.name,
        routeParams: currentRoute?.params,
        enabled: !props.hideBottomNavigation,
    });
    
    return <View style={{ flex: 1, backgroundColor: PlaceColors(findifyDataContext).background.get() }}>
        {normalizeViewChildren(props.children)}
        {!props.hideBottomNavigation &&
            <FindifyNavigation navigation={props.navigation} />
        }
    </View>;
};  
